import { Activity } from "lucide-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import AppCard from "../../components/AppCard";
import SignupStepIndicator from "./SignupStepIndicator";

interface Props {
  step: number;
  totalSteps: number;
  title: string;
  subtitle: string;
  children: ReactNode;
}

export default ({ step, totalSteps, title, subtitle, children }: Props) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6 text-slate-900 selection:bg-indigo-100">
      <div className="relative w-full max-w-[480px] space-y-8 py-8">
        <div className="text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-indigo-600 shadow-sm">
            <Activity className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900">Quantira</h1>
          <p className="mt-2 text-xs font-medium text-slate-500">Business Intelligence Platform</p>
        </div>

        <AppCard className="border-slate-200 p-8 shadow-sm">
          <div className="space-y-6">
            <div className="space-y-3 text-center">
              <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
              <p className="text-sm text-slate-500">{subtitle}</p>
              <div className="pt-2">
                <SignupStepIndicator currentStep={step} totalSteps={totalSteps} />
              </div>
            </div>

            {children}
          </div>
        </AppCard>

        <p className="text-center text-sm text-slate-500">
          Already have an account?{" "}
          <Link to="/user-login" className="font-medium text-indigo-600 transition hover:text-indigo-500">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};
